import {
  AttacheUploadFile,
  IlClass,
  IlLocationInterface,
  IlLocationTypeEnum,
  IlOnlineLocation,
  IlPhysicalLocation,
  IlSession
} from '@queries/generated';

export interface GroupedILClass extends Partial<IlClass> {
  group: ILClassGroupEnum;
}

interface ILCourseOwner {
  gid: string;
}

export interface ILCourseItemAttributes {
  gid?: string;
  name?: string;
  trackAttendance?: boolean;
  trackGrade?: boolean;
}

export enum ILClassGroupEnum {
  Today = 0,
  Upcoming = 1,
  Previous = 2
}

export interface ILSessionAttributes {
  id?: number;
  ilLocationId: string;
  startsAt: string;
  endsAt: string;
  timeZone: string;
  daysAfterFirstSession?: number;
}

export interface ILCourseAttributes {
  name?: string;
  description?: string;
  ilCourseItems?: ILCourseItemAttributes[];
  instructorFiles?: AttacheUploadFile[];
  learnerFiles?: AttacheUploadFile[];
  owner?: ILCourseOwner;
}

export enum ILSessionState {
  Active = 'active',
  Upcoming = 'upcoming',
  Unfinished = 'unfinished',
  Finished = 'finished'
}

export interface ILSessionDate {
  startsAt?: string;
  endsAt?: string;
  timeZone?: string;
}

export type ILEitherLocation = IlPhysicalLocation & IlOnlineLocation;

export type RecurrableSession = IlSession & {
  daysAfterFirstSession?: number;
};

export function isOnline(location: IlLocationInterface): location is IlOnlineLocation {
  return location.type === IlLocationTypeEnum.IlOnlineLocation;
}

export function isPhysical(location: IlLocationInterface): location is IlPhysicalLocation {
  return location.type === IlLocationTypeEnum.IlPhysicalLocation;
}
